import React from "react";
import { View } from "react-native";
import NumericInput from "react-native-numeric-input";
import InputSpinner from "react-native-input-spinner";
import { attributes } from "../../theme";

const FormTextInput = ({
  disabled,
  field: { name, onChange, value },
  minValue,
  maxValue,
  initValue
}) => (
  <View>
    <InputSpinner
      // rightButtonBackgroundColor={attributes.mainColor}
      // leftButtonBackgroundColor={attributes.mainColor}
      // iconStyle={{ color: attributes.backgroundColor }}
      color={attributes.mainColor}
      onChange={onChange(name)}
      value={value || initValue}
      min={minValue}
      max={maxValue}
      width={170}
      containerStyle={{width: 170}}
      inputStyle={{width: 50}}
      style={{
        padding: 5
      }}
    />
  </View>
);
// https://github.com/marcocesarato/react-native-input-spinner
export default FormTextInput;
